"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../Constant");

var _theme;

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n            outline: 4px solid ", ";\n            outline-offset: ", ";\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n            > span:first-child,\n            > img:first-child,\n            > svg:first-child,\n            h1 > :first-child,\n            h2 > :first-child,\n            h3 > :first-child,\n            h4 > :first-child,\n            h5 > :first-child,\n            h6 > :first-child {\n              box-shadow: 0 0 0 4px ", ";\n              /* Visible outline for high contrast mode */\n              outline: 2px solid transparent;\n            }\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  list-style: none;\n  outline: none;\n\n  &::-webkit-details-marker {\n    display: none;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  /* Focus styles are on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    /* A summary element can only take phrasing content or a heading as a child. If a heading is used, this will place focus on the first child of that heading. */\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var focusColor = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, "homepoint", _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme, "caliber", _Constant.Color.CALIBER_PASTEL_BLUE), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme));
/**
 * The summary element supports the `list-style` property, which allows us to remove the disclosure triangle.
 * However, Chromium-based browsers have a bug that requires us to use the `-webkit-details-marker` pseudo-element.
 * Link to the Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=590014
 */

var Summary = _styledComponents.default.summary(_templateObject(), function (props) {
  return props.focusPlacement === 'firstElement' ? (0, _styledComponents.css)(_templateObject2(), focusColor) : (0, _styledComponents.css)(_templateObject3(), focusColor, props.outlineOffset);
});

Summary.propTypes = {
  /** Sets focus outline to wrap around either the first icon element or the summary element */
  focusPlacement: _propTypes.default.oneOf(['firstElement', 'default']),

  /** A positive value moves the focus outline away from the element. A negative value moves the outline inside the element. */
  outlineOffset: _propTypes.default.string
};
Summary.defaultProps = {
  focusPlacement: 'default',
  outlineOffset: '-4px'
};
var _default = Summary;
exports.default = _default;